import { ComponentStyleConfig } from '@chakra-ui/react';

export const divider: ComponentStyleConfig = {
  baseStyle: {
    borderColor: 'border',
    marginTop: 'md',
    marginBottom: 'md',
  },
};
